import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import PageLayout from 'views/PageLayout.js';

const AboutPage = () => {

    const values = [
        { icon: 'fas fa-shield-alt', title: 'No compromise', copy: 'The minimum standard is not good enough for our customers. Every device is built to a higher bar.' },
        { icon: 'fas fa-moon', title: 'Peace of mind, always', copy: 'Assurance while you sleep, while you work, and while you are away from home.' },
        { icon: 'fas fa-flag-usa', title: 'Built in the U.S.A.', copy: 'Manufactured and engineered here, and trusted in tens of thousands of homes for over a decade.' },
    ];

    return (
        <PageLayout
            eyebrow={'About Aqua Link'}
            title={`Tomorrow's Technology for Today's Home`}
            subtitle={'We take a different approach to protecting your home and possessions.'}
            maxWidth={1040}>

            {/* Mission lead */}
            <p style={{
                ...Appearance.textStyles.body({ fontSize: Utils.isMobile() ? 17 : 20, lineHeight: 1.6, color: Appearance.colors.text() }),
                maxWidth: 720,
                margin: '0 auto',
                textAlign: 'center',
            }}>
                {'At Aqua Link, our mission is to give homeowners greater peace of mind through reliable, early detection of water leaks before they become costly disasters. We design dependable solutions that help protect homes and families by identifying potential problems at their earliest stages and delivering the information people need to act quickly. With safety at the heart of everything we do, we are committed to creating long-lasting, trustworthy technology that is always watching—even when you can\'t be.'}
            </p>

            {/* Values */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: Utils.isMobile() ? '1fr' : 'repeat(3, 1fr)',
                gap: Utils.isMobile() ? 32 : 40,
                marginTop: Utils.isMobile() ? 56 : 96,
            }}>
                {values.map((v, index) => (
                    <div key={index} style={{
                        ...Appearance.styles.card(),
                        boxShadow: Appearance.boxShadow.card,
                        padding: Utils.isMobile() ? 28 : 32,
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                            <i className={v.icon} style={{ fontSize: 19, color: Appearance.colors.primary(), flexShrink: 0 }} />
                            <h3 style={{ ...Appearance.textStyles.subHeading({ fontSize: 18 }), margin: 0 }}>{v.title}</h3>
                        </div>
                        <p style={Appearance.textStyles.body({ fontSize: 15 })}>{v.copy}</p>
                    </div>
                ))}
            </div>
        </PageLayout>
    );
};

export default AboutPage;
